import type { ReactNode } from 'react';

export type TabItem = { value: string; label: ReactNode };

/** Underline tabs. A string list is shorthand for value === label. */
export function Tabs({
  items,
  value,
  onChange,
  className = '',
}: {
  items: Array<string | TabItem>;
  value: string;
  onChange: (v: string) => void;
  className?: string;
}) {
  const list = items.map((i) => (typeof i === 'string' ? { value: i, label: i } : i));
  return (
    <div className={`ui-tabs ${className}`} role="tablist">
      {list.map((i) => (
        <button
          key={i.value}
          role="tab"
          aria-selected={i.value === value}
          className={i.value === value ? 'active' : ''}
          onClick={() => onChange(i.value)}
        >
          {i.label}
        </button>
      ))}
    </div>
  );
}
